import React from 'react'
import { Link } from 'react-router-dom'
import { trackEvent } from '../utils/analytics'

const Schedulewedget = () => {
  return (
    <div className='fixed bottom-40 right-6 z-50 cursor-pointer' >
      <Link to='/contact' className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-xl shadow-md" onClick={() => { trackEvent('Booking', 'click_book_now', 'schedule_widget'); window.scrollTo({ top: 0, behavior: "smooth" }); }}>Book Now</Link>
    </div>
  )
}

export default Schedulewedget
